export enum StudioType {
  CHAT_AI = 'chat-ai',
  VOICE_AI = 'voice-ai',
  TICKET_AI = 'ticket-ai',
  EMAIL_AI = 'email-ai',
}

export const STUDIO_TYPE_LABELS: Record<StudioType, string> = {
  [StudioType.CHAT_AI]: 'Chat AI Studio',
  [StudioType.VOICE_AI]: 'Voice AI Studio',
  [StudioType.TICKET_AI]: 'Ticket AI Studio',
  [StudioType.EMAIL_AI]: 'Email AI Studio',
};

/**
 * The studios that have a Train A.I. page.
 *
 * Shared rather than per-app because both sides gate on it and must not drift:
 * the frontend uses it for the route, the sidebar entry, and every in-app link,
 * and the backend uses it to pick the Train A.I. reminder email's recipients. If
 * the two lists disagree, that email points a studio at a page it cannot open.
 */
export const TRAIN_AI_STUDIO_TYPES = [StudioType.CHAT_AI, StudioType.TICKET_AI];
